module.exports = __webpack_public_path__ + "img/reglementaire.efb632ce.svg";